export default "__VITE_ASSET__7f3d154a__"